export function downloadFile(url) {
    const win = window.open(url, '_blank');
    win.location = url;
}



// WEBPACK FOOTER //
// ./src/utilities/download.jsx